import polybool from 'polybooljs';

import { round } from './round';
import constants from '../settings/constants';

export function roundVertices(polygon) {
  return {
    ...polygon,
    regions: polygon.regions.map(region =>
      region.map(vertex =>
        vertex.map(point => round(point, constants.VERTEX_ROUNDING_PRECISION))
      )
    ),
  };
}

export function mergePolygons(poly1, poly2) {
  poly1 = roundVertices(poly1);
  poly2 = roundVertices(poly2);
  return polybool.union(poly1, poly2);
}
